<template>
  <div :class="$style.counter" v-html="htmlCounterText" />
</template>

<script>
  export default {
    name: 'RbvTravelDestinationsMapPropertiesCounter',
    props: ['count'],
    computed: {
      htmlCounterText () {
        if(!this.count) {
          return 'No Properties found'
        } else {
          return `<b>${this.count}</b> ${this.count > 1 ? 'Properties': 'Property'} found`
        }
      }
    }
  }
</script>

<style lang="stylus" module>

  .counter {
    color #455A64
  }

</style>
